module.exports = __webpack_public_path__ + "f8a0a7a213123187a50c7851a6499287.pdf";